// @owners { team: patients-team }
import { NavigationService } from '@alto/navigation';

export const useIsInCheckout = () => {
  const currentRoute = NavigationService.getCurrentRouteName();
  return currentRoute && ['RouteCheckout', '/checkout'].includes(currentRoute);
};
